import { render, staticRenderFns } from "./consent-banner.vue?vue&type=template&id=2c6223d3&"
import script from "./consent-banner.vue?vue&type=script&lang=js&"
export * from "./consent-banner.vue?vue&type=script&lang=js&"
import style0 from "./consent-banner.vue?vue&type=style&index=0&id=2c6223d3&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports